<p-image 
    #myExpand 
    (onHide)="onHide()"
    [src]="srcBase64" 
    alt="Expand the image" 
    width="250" 
    [preview]="true">
</p-image>